import { createSelector, createFeatureSelector } from '@ngrx/store';

import { WithinCyclePerformanceState } from '../../models/within-cycle-performance.model';
import { getLatestWeek } from '../reducers/within-cycle-performance.reducer';

export const getWithinCyclePerformanceState = createFeatureSelector<WithinCyclePerformanceState>(
  'within-cycle-performance',
);

export const getSelectedCycleId = createSelector(
  getWithinCyclePerformanceState,
  (s) => s.selectedCycleId,
);

export const getSelectedBarnId = createSelector(
  getWithinCyclePerformanceState,
  (s) => s.selectedbarnId,
);

export const getRefValueSheetDataSeries = createSelector(
  getWithinCyclePerformanceState,
  (s) => s.refValueSheetDataSeries,
);

export const getWdoDataSeries = createSelector(
  getWithinCyclePerformanceState,
  (s) => s.wdoDataSeries,
);

export const getObservations = createSelector(
  getWithinCyclePerformanceState,
  (state) => state.observations,
);

export const getAvailableWeeks = createSelector(getObservations, (observations) =>
  observations ? Array.from({ length: getLatestWeek(observations) }, (_, i) => i + 1) : [],
);

export const getGrowthPredictionDataSeries = createSelector(
  getWithinCyclePerformanceState,
  (s) => s.growthPredictionDataSeries,
);
